var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWineGlass(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.57789,
    height: 51.11354,
    viewBox: "0 0 45.57789 51.11354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea5a47;}.cls-2{fill:#d22f27;}.cls-3{stroke-linecap:round;stroke-linejoin:round;}.cls-3,.cls-4{fill:none;stroke:#000;stroke-width:2px;}.cls-4{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.17729 17.96153 8.37788 17.96153 8.37788 8.55119 28.78248 8.55119 38.17729 8.55119 38.17729 17.96153"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.96149,16.39314c0,8.66198-7.02192,15.6839-15.6839,15.6839s-15.6839-7.02192-15.6839-15.6839"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.17729,16.39314v-7.84195h-5.9362c.46785,4.96764,.22977,16.62792-10.81248,23.40744,.60752,.07144,1.22233,.11841,1.84898,.11841,8.66198,0,15.6839-7.02192,15.6839-15.6839h-.7842Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 10.73046,
    y1: 50.11354,
    x2: 35.82471,
    y2: 50.11354
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.27759,
    y1: 32.07705,
    x2: 23.27759,
    y2: 50.11354
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.96149,16.39314c0,2.5604-.61355,4.97752-1.70162,7.11234-2.59294,5.08739-7.88069,8.57157-13.98228,8.57157-8.66198,0-15.6839-7.02192-15.6839-15.6839"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.59368,
    y1: 1.49344,
    x2: 7.59368,
    y2: 16.39314
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.96149,
    y1: 1.49344,
    x2: 38.96149,
    y2: 16.39314
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7.20159,
    y1: 8.94329,
    x2: 38.56939,
    y2: 8.94329
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineGlass);
export default __webpack_public_path__ + "static/media/wine-glass.6633159f3e892a726fb1eb3404bc882c.svg";
export { ForwardRef as ReactComponent };